export function getActivityTitle({ activity, categories, t, i18n }) {
  if (!activity) {
    return t('activity.default_title');
  }

  // Si on a un titre formaté (priorité)
  if (activity.title) {
    // Si c'est un objet multilingue
    if (typeof activity.title === 'object') {
      return activity.title[i18n.language] || activity.title.en || activity.title.fr || t('activity.default_title');
    }
    // Si c'est une string
    if (typeof activity.title === 'string') {
      return activity.title;
    }
  }

  // Fallback: essayer d'utiliser le type d'activité
  if (activity.type) {
    // Si le type est un objet avec des labels
    if (typeof activity.type === 'object' && activity.type.labels) {
      return activity.type.labels[i18n.language] || activity.type.labels.en || activity.type.labels.fr || t('activity.default_title');
    }
    // Si le type est une string brute (cas des notifications)
    if (typeof activity.type === 'string') {
      return activity.type;
    }
  }

  return t('activity.default_title');
}

// Génère un titre d'activité côté serveur (sans i18n, pour stockage dans activity.title)
export function getActivityTitleServerSide({ typeLabels, subtype, subtypeLabels }) {
  // Génère un objet { fr: ..., en: ... }
  const result = {};
  if (!typeLabels) {
    result.fr = 'Activité';
    result.en = 'Activity';
    return result;
  }
  if (subtype && subtypeLabels) {
    result.fr = `${typeLabels.fr} ${subtypeLabels.fr}`;
    result.en = `${typeLabels.en} ${subtypeLabels.en}`;
    return result;
  }
  result.fr = typeLabels.fr;
  result.en = typeLabels.en;
  return result;
} 